import { formatDate } from "../helpers";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import IconRoundButton from "../../_utils/CommonButtons/IconRoundButton";
import SvgComponent from "../../_utils/SVGComponent";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";

// turns 1 into 1st, 2 into 2nd, 3 into 3rd and so on and so forth
const ordinalize = (num) => {
  const numAsString = `${num}`;
  const unitsDigit = +numAsString.at(-1);
  const tensDigit = +numAsString.at(-2);
  let suffix = "th";

  // 11th 12th 13th 113th
  if (tensDigit === 1) return numAsString + suffix;

  switch (unitsDigit) {
    case 1:
      suffix = "st";
      break;
    case 2:
      suffix = "nd";
      break;
    case 3:
      suffix = "rd";
      break;
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 0:
    default:
      suffix = "th";
      break;
  }
  return numAsString + suffix;
};
export default function ScheduleTxnOccurrencesPopup({
  occurrences,
  closeCallback,
}) {
  const [animate, setAnimate] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  const occrs = occurrences;

  const tableRows = occrs?.map((o, e) => {
    return (
      <div
        className={`flex flex-row justify-between w-full items-center text-text-primary text-font-sm text-center py-padding-sm ${
          e === occurrences.length - GlobalConfiguration.lengthCheckOne
            ? "border-none"
            : "border-b border-primary-nav"
        }`}
        key={e}
      >
        <div className="w-width-full text-text-secondary text-font-sm">
          {ordinalize(e + GlobalConfiguration.lengthCheckOne) + " occurrence"}
        </div>
        <div className="w-width-full">{formatDate(o)}</div>
      </div>
    );
  });
  return (
    <>
      <div className="fixed left-left-base top-top-base w-width-full h-height-full z-z-index-modal bg-PopUp-BackDrop opacity-dark-opacity" />
      <div className="fixed left-left-base top-top-base w-width-full h-height-full z-z-index-max">
        <div className="flex Qmd:flex-col w-width-full h-height-full justify-center items-center Qmd:gap-gap-xl">
          <div
            className={` w-standard-largePopup-width  h-popup-height    Qmd:max-h-labels-popup-height Qmd:h-auto  Qmd:w-small-popup-width bg-primary-bg  Qmd:rounded-border-radius-md overflow-hidden animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"} rounded-xl flex flex-col`}
          >
            <div className="heading-section flex  Qmd:flex p-padding-md flex-row justify-between items-center Qmd:rounded-t-border-radius-md ">
              <div className="text-text-primary text-font-md font-semibold">
                {TEXT?.OCCURRENCES_TIMELINE}
              </div>

              <IconRoundButton
                enabledBgColor="var(--primary-nav)"
                isLoading={false}
                handleFunction={() => {
                  setAnimate(true);
                  setTimeout(() => {
                    closeCallback();
                  }, IntervalConfiguration.intervalSemiMid);
                }}
                icon={ICONS?.CLOSE}
                title={TEXT?.CLOSE}
                hoverOption="white"
              />
            </div>

            <div className="bg-primary-nav-act lg:bg-primary-nav flex justify-between w-width-full p-padding-xs shadow-box-shadow-bottom">
              <div className="text-center text-text-primary w-width-full border-r border-primary-bg">
                {TEXT?.OCCURRENCE}
              </div>
              <div className="text-center text-text-primary w-width-full">
                {TEXT?.DATE}
              </div>
            </div>

            <div className="flex  flex-col  justify-start Qmd:items-start items-center flex-1  Qmd:h-[fit-content] Qmd:pb-padding-base  overflow-y-auto">
              <div className="  flex flex-col w-full  Qmd:w-width-full rounded-border-radius-sm Qmd:rounded-t-none items-center lg:px-padding-md  overflow-y-scroll px-padding-md ">
                {tableRows}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
